import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationRuleFormData } from '@/features/notification-rules/schemas/create-notification-rule.schema.ts';
import { useSession } from '@/services/providers/session-provider.tsx';

export const usePostNotificationRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();
  const { userId } = useSession();

  return useMutation({
    mutationFn: (notificationRule: NotificationRuleFormData) => {
      return toast.promise(
        client.post(`/users/${userId}/notification-rules`, notificationRule),
        {
          loading: 'Creating notification rule...',
          success: 'Successfully created the notification rule.',
          error: (_: unknown) =>
            `Uh oh, there was an error with creating the notification rule.`,
        }
      );
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['users', userId, 'notification-rules'] });
    },
  });
};
